module.exports = __webpack_public_path__ + "img/payment-success.af46285a.svg";